// Slider Starts
$(document).ready(function(){
    $('.slider').bxSlider({
        auto: true,
        autoStart: true,
        autoDirection: 'next',
        pager: true,
        controls: true,
        nextText: '',
        prevText: '',
    });
    $('.slider__main').bxSlider({
        auto: true,
        autoStart: true,
        autoDirection: 'next',
        pager: true,
        nextText: '',
        prevText: '',
    });
});
// Slider Ends



// WEBPACK FOOTER //
// ./slider.js